import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["type", "disabled", "autofocus"]
const _hoisted_2 = {
  key: 0,
  class: "w-icon-loading"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 按钮 ")

import { computed, PropType } from 'vue'
import { ButtonType } from './type';

 const __default__ = {name: 'WButton'} 
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: String as PropType<ButtonType>,
    default: 'primary'
  },
  size: String,
  icon: {
    type: String,
    default: ''
  },
  nativeType: {
    type: String,
    default: 'button'
  },
  loading: Boolean,
  disabled: Boolean,
  plain: Boolean,
  round: Boolean,
  circle: Boolean,
  autofocus: Boolean,
},
  setup(__props) {

const props = __props


const buttonDisabled = computed(() => {
  return props.disabled
})
const buttonSize = computed(() => {
  return props.size
})

const classs = computed(() => [
  'w-button',
  `w-button--${props.type}`,
  buttonSize.value ? 'w-button--' + buttonSize.value : '',
  {
    'is-loading': props.loading,
    'is-disabled': buttonDisabled.value,
    'is-plain': props.plain,
    'is-round': props.round,
    'is-circle': props.circle
  }
])



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_unref(classs)),
    type: __props.nativeType,
    disabled: _unref(buttonDisabled) || __props.loading,
    autofocus: __props.autofocus
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _createCommentVNode("", true),
    (__props.icon && !__props.loading)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(__props.icon)
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _hoisted_4
        ], 64))
  ], 10, _hoisted_1))
}
}

})